module.exports = __webpack_public_path__ + "img/cocteleria_2.35ab83d8.jpeg";